import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { Input } from "../../../../../_metronic/_partials/controls";
import { BlockOrg } from "../../../../RoleChecker";

export function PartnerEditForm({
  savePartner,
  actionsLoading,
  partner,
  roleMaster,
  onHide,
  id,
}) {
  // Validation schema
  // const shape = {
  //   name: Yup.string()
  //     .min(3, "Minimum 3 symbols")
  //     .max(50, "Maximum 50 symbols")
  //     .required("Nama Access Role Wajib Diisi"),
  //   email: Yup.string()
  //     .email()
  //     .required("Email wajib diisi"),
  // };
  const [shape, setShape] = useState({
    name: Yup.string()
      .min(3, "Minimum 3 symbols")
      .max(50, "Maximum 50 symbols")
      .required("Nama Access Role Wajib Diisi"),
    email: Yup.string()
      .email()
      .required("Email wajib diisi"),
  });
  useEffect(() => {
    if (id) {
      setIsDisable(true);
    } else {
      setShape((prev) => ({
        ...prev,
        password: Yup.string().required("Password wajib diisi"),
        confirmation_password: Yup.string().when("password", {
          is: (password) => password && password.length > 0,
          then: Yup.string()
            .oneOf(
              [Yup.ref("password"), null],
              "Konfirmasi password harus sama dengan password!"
            )
            .required("Konfirmasi password wajib diisi!"),
        }),
      }));
    }
  }, [id]);

  const PartnerEditSchema = Yup.object().shape(shape);

  const [isDisable, setIsDisable] = useState(false);

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={partner}
        validationSchema={PartnerEditSchema}
        onSubmit={(values) => {
          savePartner(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values }) => (
          <>
            <Modal.Body className="overlay overlay-block cursor-default">
              {actionsLoading && (
                <div className="overlay-layer bg-transparent">
                  <div className="spinner spinner-lg spinner-success" />
                </div>
              )}
              <Form className="form form-label-right">
                <div className="form-group row">
                  <div className="col">
                    <Field
                      name="name"
                      component={Input}
                      placeholder="Masukkan Nama Mitra..."
                      label="Nama Mitra"
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="email"
                      component={Input}
                      placeholder="Masukan Email..."
                      label="Email"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col">
                    {id && (
                      <label>
                        <Field
                          name="change_pass"
                          type="checkbox"
                          checked={values.change_pass}
                          onChange={(e) => {
                            setFieldValue(e.target.name, e.target.checked);
                            setIsDisable(!isDisable);
                            setFieldValue("password", "");
                          }}
                        />{" "}
                        Change&nbsp;
                      </label>
                    )}
                    <Field
                      name="password"
                      disabled={isDisable}
                      component={Input}
                      type="password"
                      placeholder="Masukkan Password"
                      label="Password"
                      value={undefined}
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="confirmation_password"
                      component={Input}
                      type="password"
                      placeholder="Konfirmasi Password"
                      label="Konfirmasi Password"
                    />
                  </div>
                </div>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              {BlockOrg() && (
                <button
                  type="submit"
                  onClick={() => handleSubmit()}
                  className="btn btn-primary btn-elevate"
                >
                  Save
                </button>
              )}
            </Modal.Footer>
          </>
        )}
      </Formik>
    </>
  );
}
